import { Linking } from 'react-native';
import { PRIVACY_POLICY_URL, TOS_URL, PRIVACY_STATEMENT_URL } from '../../constants/endpoints';

export function openTerms() {
  Linking.openURL(TOS_URL);
}

export function openPrivacy() {
  Linking.openURL(PRIVACY_POLICY_URL);
}

export function openPrivacyStatement() {
  Linking.openURL(PRIVACY_STATEMENT_URL);
}
